(function() {
  'use strict';

  angular
    .module('traineeWebApp.resources')
    .controller('MessageBoxCtrl', MessageBoxCtrl)
    .factory('modalHelper', modalHelper);

  MessageBoxCtrl.$inject = ['$scope', '$modalInstance', 'setup'];
  modalHelper.$inject = ['$modal', '$timeout'];

  function MessageBoxCtrl($scope, $modalInstance, setup) {
    $scope.setup = setup;

    $scope.close = function(result) {
      $modalInstance.dismiss(result);
    };
  }

  function modalHelper($modal, $timeout) {
    function messageBox(setup, complete, error) {
      var modal = $modal.open({
        templateUrl: 'modals/messageBox.html',
        controller: 'MessageBoxCtrl',
        resolve: {
          setup: function() {
            return setup;
          }
        }
      });
      if (complete) {
        modal.result.then(complete, error);
      }
      return modal;
    }

    function actionBox($scope, settings) {
      _.defaults(settings, {
        title: 'Confirm',
        action: null,
        message: null,
        messageRunning: 'Please wait',
        buttonOk: 'OK',
        buttonCancel: 'Cancel',
        running: false,
        templateUrl: 'pages/modals/actionBox.html'
      });

      var modal;
      var dlgScope = $scope.$new();
      dlgScope.settings = settings;

      settings.onOk = function() {
        settings.running = true;
        settings.action(function() {
          $timeout(function() {
            modal.close();
          }, 500);
        });
      };

      modal = $modal.open({
        templateUrl: settings.templateUrl,
        scope: dlgScope
      });
    }

    return {
      messageBox: messageBox,
      actionBox: actionBox
    }
  }
})();
